<template>
  <el-row>
    <el-menu class="el-menu">
      <el-menu-item index="0" @click="menuClick('0', '概览')" v-if="this.$store.state.userId !== 'worker'">
        <template slot="title">
          <i class="el-icon-menu"></i>
          <span>概览</span>
        </template>
      </el-menu-item>
<!-- 
      <el-menu-item index="1" @click="menuClick('1', '公开方法')" v-if="this.$store.state.userId !== 'worker'">
        <template slot="title">
          <i class="el-icon-search"></i>
          <span>公开方法</span>
        </template>
      </el-menu-item> -->

      <el-submenu index="9" v-if="this.$store.state.userId !== 'worker'">
        <template slot="title">
          <i class="el-icon-user"></i>
          <span>私有空间</span>
        </template>
        <el-menu-item index="9-1" @click="menuClick('9-1', '录入分离方法')"  style="display: none;">
          <template slot="title">
            <i class="el-icon-goods"></i>
            <span>录入分离方法</span>
          </template>
        </el-menu-item>
        <el-menu-item index="9-2" @click="menuClick('9-2', '查看分离方法')">
          <template slot="title">
            <i class="el-icon-search"></i>
            <span>分离方法列表</span>
          </template>
        </el-menu-item>
        <!-- <el-menu-item index="9-3" @click="menuClick('9-3', '格式转换')">
          <template slot="title">
            <i class="el-icon-refresh"></i>
            <span>格式转换</span>
          </template>
        </el-menu-item> -->
        <el-menu-item index="9-4" @click="menuClick('9-4', '分离柱管理')" v-if="this.$store.state.userId === 'datacenter' || this.$store.state.userId === 'root'">
          <template slot="title">
            <img src="../assets/imgs/sepa.svg" style="width: 12px; margin:0 8px;" v-if="clickSepa">
            <img src="../assets/imgs/unsepa.svg" style="width: 12px;margin:0 8px;" v-if="!clickSepa">
            <span>分离柱管理</span>
          </template>
        </el-menu-item>
        <el-menu-item index="9-5" @click="menuClick('9-5', '供应商管理')" v-if="this.$store.state.userId === 'datacenter' || this.$store.state.userId === 'root'">
          <template slot="title">
            <img src="../assets/imgs/unclickcompany.svg" style="width: 12px;margin:0 8px;" v-if="!clickCompany">
            <img src="../assets/imgs/clickcompany.svg" style="width: 12px;margin:0 8px;" v-if="clickCompany">
            <span>供应商管理</span>
          </template>
        </el-menu-item>
      </el-submenu>
      <el-submenu index="10">
        <template slot="title">
          <i class="el-icon-data-analysis"></i>
          <span>远程设置</span>
        </template>
        <el-menu-item index="10-1"  @click="menuClick('10-1', '远程管理')">
          <template slot="title">
            <i class="el-icon-document"></i>
            <span>远程管理</span>
          </template>
        </el-menu-item>
      </el-submenu>
      
      <el-menu-item index="11" @click="menuClick('11', '密钥生成')" v-if="this.$store.state.userId === 'worker'">
        <template slot="title">
           <img src="../assets/imgs/psd.svg" style="width: 12px;margin:0 8px;">
          <span>密钥生成</span>
        </template>
      </el-menu-item>
    </el-menu>
  </el-row>
</template>

<script>
export default {
  name: 'Navigator',
  data() {
    return {
      clickSepa: false,
      clickCompany: false,
    }
  },
  methods: {
    menuClick: function(index, title) {
      // this.$store.commit('updateIndexTrigger', index);
      this.$store.commit('updateTabs', {
        tag: 'add',
        tab: {
          name: index,
          title: title,
        },
      })
      if (index === '9-4') {
        this.clickSepa = true
        this.$store.commit('updateTabs', {
        tag: 'remove',
        targetName: 'sepa-add-specifications'
      })
      } else {
        this.clickSepa = false
      }
      if (index === '9-5') {
        this.clickCompany = true
      } else {
        this.clickCompany = false
      }
      if(index === '10-1'){
        this.$store.commit('updateTabs', {
        tag: 'remove',
        targetName: 'remoteList'
      })
      }
      if(index === '9-2'){
     this.$store.commit('updateTabs', {
        tag: 'remove',
        targetName: 'methods'
      })
      }
    },
  },
}
</script>

<style scoped></style>
